export const source_system_mapping = {
    SYS01: 'sys01', // wd
    SYS02: 'sys02', // sf
    SYS03: 'sys03', // entra
}

export const status_mapping = {
    'failed_auto-retry' : 'failed/retry',
    'failed': 'failed', 
    'pending': 'pending',
    'canceled': 'canceled',
    'error': 'error',
    'successful': 'successful',
    'pending_nonbiometric-verification': 'pending-nonbiometric',
}